// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s3-z","displaySixCardTiles":"t3-z"};